export interface IHttpStatus {
  gte: number;
  lt: number;
  tip: string;
}

// 需要触发重试的status
export const statusWillRetry = [408, 500, 502, 503, 504, 522, 524];

// 网络异常的文案
export const httpStatusSectionList: IHttpStatus[] = [
  { gte: 300, lt: 399, tip: '服务走丢啦，请稍后再试' },
  { gte: 400, lt: 499, tip: '当前遇到点小问题，请稍后再试' },
  { gte: 500, lt: 599, tip: '服务器错误啦，请稍后再试' },
];

// 根据http状态码获取合适的文案
export const getExtraTipMessageForUser = (status: number) => {
  const findSection = httpStatusSectionList.find((section) => status > section.gte && status < section.lt);
  if (findSection) {
    return findSection.tip;
  }
  return '未知错误，请稍后再试';
};

export enum HTTP_CONTENT_TYPE {
  JSON = 'application/json',
  FORM = 'application/x-www-form-urlencoded',
}

interface IHeaderConfig {
  Accept?: string;
  'Content-Type': any;
  [k: string]: any;
}

export enum HTTP_METHOD {
  POST = 'post',
  GET = 'get',
}

interface IAnyMap {
  [k: string]: any;
}

export interface IRequestOptions {
  headers?: IHeaderConfig;
  signal?: AbortSignal;
  method?: HTTP_METHOD;
  query?: IAnyMap;
  params?: IAnyMap;
  data?: IAnyMap;
  body?: string;
  timeout?: number;
  credentials?: 'include' | 'same-origin';
  mode?: 'cors' | 'same-origin';
  cache?: 'no-cache' | 'default' | 'force-cache';
}
